import { BasePostRequest } from './core/basePostRequest';
import * as t from 'io-ts';

export class UnshareRequest extends BasePostRequest<undefined> {
    constructor(public bookingId: string, public email: string) {
        super(`bookings/${bookingId}/unshare`, {}, { email}, t.undefined);
    }
}
